<template>
    <div id="accordion" class="accordion">
        <div class="accordion--card">
            <button class="accordion--btn accordion--btn-underline" data-toggle="collapse" data-target="#collapse3"
                    aria-expanded="true" aria-controls="collapse3">
                {{ status.name }}
            </button>
            <div id="collapse3" class="collapse show" aria-labelledby="heading3">

                <div class="row mt-3">
                    <div class="col-md-12">
                        <div class="form-group form-group-1 d-flex align-items-center">
                            <div class="mr-2">Complete</div>
                            <VueToggles
                                height="30"
                                width="80"
                                font-size="14"
                                checkedBg="#60ad45"
                                uncheckedBg="#e0e1e2"
                                :value="Boolean(status.isComplete)"
                                @click="changeStatus"
                            />
                        </div>
                    </div>
                    <div class="col-12">
                        <p>{{ status.text }}</p>
                    </div>
                    <div class="col-12">
                        <div
                            v-for="(check, index) in status.checklist"
                            :key="index"
                            class="form-group form-group-1"
                        >
                            <div class="form-check">
                                <input
                                    class="form-check-input-checkbox"
                                    type="checkbox"
                                    id="home-office"
                                    v-model="check.isChecked"
                                >
                                <label class="form-check-label" for="home-office">{{ check.title }}</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-12" v-if="status.show_note">
                        <div class="form-group form-group-1">
                            <label for="" class="form-label">Comments
                            </label>
                            <textarea type="text" class="form-control height-2" v-model="status.comment"></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group form-group-1">
                <div class="btns-wrap" style="justify-content: flex-end;">
                    <button class="btn btn--secondary w-100 w-sm-auto" @click="saveData">Save</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import StatusService from "../../../../Status/resources/js/services/StatusService";
import ModalHandler from "../../../../../../resources/js/mixins/ModalHandler";

export default {
    name: 'StatusItemInfo',

    props: {
        userStatusInfo: {
            type: Object
        },
        userId: {
            type: Number,
            required: true
        },
        isToggleable: Boolean
    },
    mixins: [ModalHandler,],
    data() {
        return {
            currentStatus: {},
            status: {
                isEditable: null,
                name: null,
                id: null,
                show_note: null,
                status: null,
                text: null,
                checklist: null,
                isComplete: false,
                comment: null,
                forUpdate: false,
            },
        }
    },
    methods: {
        changeStatus() {
            if (this.status.isEditable && this.isToggleable) {
                this.status.isComplete = !this.status.isComplete;
            } else {
                this.$showInfoSwal('You can not change status of stage.' +
                    ' Please complete or cancel previous steps or activate user.')
                return
            }
        },
        async saveData() {
            const payload = {
                applicant_id: this.status.applicant_id,
                checklist: this.status.checklist,
                status_item_template_id: this.status.id,
                isComplete: this.status.isComplete,
                note: this.status.comment
                }
            this.$showLoadingMessage()

                try {
                    const {data: response} = await StatusService.updateStatusForApplicant(this.userStatusInfo.id, payload)
                    this.userStatus = response
                    this.$showSuccessMessage('Your data was updated!')
                    setTimeout( () => {
                        this.reloadPage()
                    }, 1000)
                } catch (e) {
                this.$showErrorMessage('Your information was not updated. Please try again.')
                    console.error(e)
                }
        },
        setExistData() {
            this.currentStatus = this.userStatusInfo
            this.status = {
                isEditable: this.userStatusInfo.isEditable,
                applicant_id: this.userStatusInfo.applicant_id,
                name: this.userStatusInfo.template.name,
                id: this.userStatusInfo.template.id,
                show_note: this.userStatusInfo.template.show_note,
                status: this.userStatusInfo.template.status,
                text: this.userStatusInfo.template.text,
                checklist: this.userStatusInfo.checklist,
                isComplete: this.userStatusInfo.isComplete,
                comment: this.userStatusInfo.note ?? '',
                updated_at: this.userStatusInfo.updated_at
            }
        }
    },
    mounted() {
        if (this.userStatusInfo) {
            this.setExistData()
        }
    },
    watch: {
        'userStatusInfo': {
            handler: function (newStatus, oldStatus) {
                if (newStatus !== this.currentStatus) {
                    this.setExistData();
                }
            },
            immediate: true,
        },
    },


}

</script>


<style scoped>

</style>
